import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { camelCase_to_Sentence, isEventDependentSubscriptionState, isPostponedSubscriptionState, SubscribedStatus, toTitleCase, } from '@iotv/datamodel';
import { IOTV_Thing_EventType } from '@iotv/iotv-v3-types';
import { Autocomplete, Stack, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { toDatePickerFormat } from '../../../data/TypeHelpers';
import { AutosizedTextField } from '../../common/AutosizedTextField';
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * CRA — 2025 05: Should this be deprecated?
 */
export const SubscriptionState = ({ subscriptionState, setSubscriptionState, style, disabled = false }) => {
    debug && console.log('SubscriptionState got', subscriptionState);
    debug && console.log('SubscriptionState reapplyAfterDateMs', subscriptionState?.reapplyAfterDateMs);
    const subscriptionStateHash = (subscriptionState?.status ?? '') +
        subscriptionState?.reapplyAfterEvent +
        subscriptionState?.reapplyAfterDateMs;
    debug && console.log('Subscription hash', subscriptionStateHash);
    useEffect(() => {
        debug && console.log('SubscriptionState used effect on ', subscriptionStateHash);
    }, [subscriptionStateHash]);
    const subscriptionStateCastEventDependent = subscriptionState;
    const subscriptionStateCastTimePostponable = subscriptionState;
    const isEventDependent = isEventDependentSubscriptionState(subscriptionState);
    const isTimePostponable = isPostponedSubscriptionState(subscriptionState);
    const components = {
        state: (_jsx(Autocomplete, { freeSolo: false,
            id: 'selectSubscriptionState',
            style,
            size: 'small',
            variant: 'outlined',
            value: subscriptionState.status,
            options: Object.values(SubscribedStatus),
            multiple: false,
            disableClearable: true,
            filterSelectedOptions: true,
            getOptionLabel: (v) => toTitleCase(camelCase_to_Sentence(v)),
            disabled,
            onChange: (_, v) => {
                if (v !== undefined)
                    setSubscriptionState({
                        ...subscriptionState,
                        status: v,
                        reapplyAfterEvent: undefined,
                        reapplyAfterDateMs: undefined,
                    });
            },
            renderInput: (params) => (_jsx(AutosizedTextField, { ...params,
                label: 'Status',
                disabled })) }, 'selectSubscriptionState')),
        eventDependent: subscriptionState.status === SubscribedStatus.POSTPONED && !isEventDependent && (_jsx(TextField, { type: 'datetime-local',
            value: subscriptionState?.reapplyAfterDateMs
                ? toDatePickerFormat(subscriptionState?.reapplyAfterDateMs)
                : new Date().toString(),
            defaultValue: toDatePickerFormat(new Date().valueOf()),
            size: 'small',
            disabled,
            onChange: (e) => {
                const reapplyAfterDateMs = new Date(e.target.value).valueOf();
                debug &&
                    console.log('Date Picker', {
                        dtlTime: toDatePickerFormat(reapplyAfterDateMs),
                        date: e.target.value,
                        reapplyAfterDateMs,
                        currentVal: subscriptionStateCastTimePostponable.reapplyAfterDateMs,
                    });
                setSubscriptionState({ ...subscriptionState, status: SubscribedStatus.POSTPONED, reapplyAfterDateMs });
            },
            label: 'Postponed until',
            InputLabelProps: {
                shrink: true,
            } }, 'eventDependent')),
        timeDependent: subscriptionState.status === SubscribedStatus.POSTPONED && !isTimePostponable && (_jsx(Autocomplete, { freeSolo: false,
            id: 'timeDependent',
            style,
            size: 'small',
            variant: 'outlined',
            options: Object.values(IOTV_Thing_EventType),
            multiple: false,
            filterSelectedOptions: true,
            disabled,
            getOptionLabel: (v) => toTitleCase(camelCase_to_Sentence(v)),
            value: subscriptionStateCastEventDependent.reapplyAfterEvent,
            onChange: (e, v) => {
                v && setSubscriptionState({ ...subscriptionState, status: SubscribedStatus.POSTPONED, reapplyAfterEvent: v });
            },
            renderInput: (params) => (_jsx(AutosizedTextField, { ...params,
                label: 'Postponed until',
                disabled })) }, 'timeDependent')),
    };
    return (_jsxs(Stack, { gap: 1, children: [components.state, components.eventDependent, components.timeDependent] }));
};
